// Vendor libraries
import { bootstrapAppModule } from 'NewAngular/utils/app-bootstrapping';
// Modules
import { ErrorPageModule } from './app.module';
bootstrapAppModule(ErrorPageModule);
